import { Stack, styled, Skeleton } from '@liscio/ui';

const Wrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  flex: 1,
  padding: theme.spacing(3),
  gap: theme.spacing(4),
}));
export const TaxDeliveryDispatchLoadingState = () => {
  return (
    <Wrapper>
      <Skeleton width="30%" />
      <Skeleton width="100%" height="100px" />
    </Wrapper>
  );
};
